import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import qs from 'query-string';
import Cookies from 'js-cookie';

const PrivateRoute = ({
  component: Component, routes, location, ...otherProps
}) => {
  const accessToken = useSelector((state) => state.auth.accessToken);

  useEffect(() => {
    if (!accessToken) {
      Cookies.set('redirect_url', qs.stringify(location));
    }
  }, [accessToken, location]);

  return (
    <Route
      {...otherProps}
      render={(props) => (accessToken
        ? <Component {...props} routes={routes} />
        : (
          <Redirect
            to={{
              pathname: '/users/callback',
              hash: location.hash,
            }}
          />
        ))}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  routes: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    component: PropTypes.func.isRequired,
    exact: PropTypes.bool,
    path: PropTypes.string,
  })),
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
    hash: PropTypes.string,
  }),
};

PrivateRoute.defaultProps = {
  routes: undefined,
  location: {},
};

export default PrivateRoute;
